import Vue from 'vue';
import { Module } from 'vuex';
import { IRootState } from '..';

// tslint:disable-next-line: interface-over-type-literal
type INotification = {
  id: number;
  type: string;
  text?: string;
  icon?: string;
  isPending?: boolean;
};

// tslint:disable-next-line: interface-over-type-literal
export type INotificationState = {
  temporaryNotifications: Record<number, INotification>;
  temporaryNotificationIds: number[];
};

export const notification: Module<INotificationState, IRootState> = {
  namespaced: true,
  state: {
    temporaryNotifications: {},
    temporaryNotificationIds: [],
  },
  getters: {
    notifications({ temporaryNotifications, temporaryNotificationIds }) {
      return [
        ...temporaryNotificationIds.map((id) => temporaryNotifications[id]),
      ];
    },
  },
  mutations: {
    createPersistentNotification(state, notification: INotification) {
      const id = notification.id;
      state.temporaryNotifications[id] = { isPending: true, ...notification };
      state.temporaryNotificationIds.push(id);
      return id;
    },
    updatePersistentNotification(state, updatedFields: Partial<INotification>) {
      if (
        !updatedFields.id ||
        !state.temporaryNotifications.hasOwnProperty(updatedFields.id)
      ) {
        return;
      }
      const notification = state.temporaryNotifications[updatedFields.id!];
      Vue.set(state.temporaryNotifications, updatedFields.id!, {
        ...notification,
        ...updatedFields,
      });
    },
    closeNotification(state, notificationId: number) {
      const notification = state.temporaryNotifications[notificationId];
      if (!notification || notification.isPending) return;
      state.temporaryNotificationIds = state.temporaryNotificationIds.filter(
        (id) => id !== notificationId,
      );
    },
  },
};
